var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",class:{
		['panel background-' +
		JSON.parse(_vm.block.attributes.background).slug]: true,
		['color-' + JSON.parse(_vm.block.attributes.color).slug]: true,
		['template-' + _vm.block.attributes.template]: true,
	},attrs:{"id":_vm.block ? _vm.block.attributes.section_name : null}},[_c('MainColumn',[_c('RenderBlocks',{attrs:{"blocks":_vm.block.innerBlocks,"parentBlock":_vm.block}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }